import { useEffect, useRef } from 'react';
import gsap from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Container, Text, Image } from '@weareconceptstudio/core';

//* Styles
import HeroStyle from './style';

//* Components
import Share from '@/components/Share';
import TitleAnim from '@/modules/_animation/Title';

gsap.registerPlugin(ScrollTrigger);

const Hero = ({ title, image_main, image_mobile, date, setImageLoad, imageLoad }) => {
	//! Ref
	const dateHeroRef = useRef();
	const imageRef = useRef();
	const shareWrapperRef = useRef();
	const triggerRef = useRef();
	const styleRef = useRef();

	useEffect(() => {
		if (imageLoad && imageRef.current) {
			gsap.fromTo([dateHeroRef.current, imageRef.current], { opacity: 0 }, { opacity: 1, duration: 0.4, ease: 'power2.in', stagger: 0.4 });
			gsap.fromTo(imageRef.current, { y: '40%' }, { y: 0, duration: 0.6, ease: 'power2.out', delay: 0.5 });
			const shareItem = styleRef.current.querySelectorAll('a');

			if (shareItem.length) {
				gsap.fromTo(shareItem, { scale: 0 }, { scale: 1, ease: 'power2.inOut', duration: 0.6, stagger: 0.07, delay: 0.5 });
			}
		}

		return () => {
			if (imageRef.current && dateHeroRef.current) {
				gsap.killTweensOf([dateHeroRef.current, imageRef.current]);
				gsap.set([dateHeroRef.current, imageRef.current], { opacity: 0 });
			}
		};
	}, [imageLoad]);

	//! pin
	useEffect(() => {
		if (imageLoad) {
			if (shareWrapperRef.current) {
				const endTrigger = document.querySelector('.description-wrap');
				const endMarker = shareWrapperRef.current.offsetHeight;
				const topMarker = shareWrapperRef.current.offsetTop;

				if (endTrigger) {
					triggerRef.current = ScrollTrigger.create({
						start: `top top+=${topMarker}`,
						end: `bottom top+=${endMarker + topMarker}`,
						trigger: shareWrapperRef.current,
						// markers: true,
						pin: true,
						pinSpacing: false,
						endTrigger: endTrigger,
					});
				}
			}
		}

		return () => {
			if (triggerRef.current) {
				triggerRef.current.kill();
			}
		};
	});

	return (
		<HeroStyle ref={styleRef}>
			<Container row>
				<div className='col-1 col-ds-12' />
				<div className='col-8 col-ds-10 col-m-12'>
					<Text
						ref={dateHeroRef}
						className='text-date font-fss-regular p1 opacity-zero'
					>
						{date}
					</Text>
					<TitleAnim
						textCenter={false}
						load={imageLoad}
					>
						<Text
							tag={'h1'}
							className={'font-larken-regular title-text h3'}
						>
							{title}
						</Text>
					</TitleAnim>
				</div>
				<div className='col-3 col-ds-2 col-m-12' />

				<div className='col-1 col-ds-12' />
				<div className='col-8 col-ds-10 col-m-12'>
					<div
						ref={imageRef}
						className={'image-wrapper opacity-zero'}
					>
						<Image
							onLoad={setImageLoad}
							double={[image_main, image_mobile ?? image_main]}
							priority={true}
						/>
					</div>
				</div>
				<div className='col-1 col-ds-1 col-m-12' />

				<div className='col-1 col-ds-1 col-m-12 shared-top'>
					<div
						ref={shareWrapperRef}
						className='share-inner-wrapper'
					>
						<Share />
					</div>
				</div>

				<div className='col-1 col-m-12' />
			</Container>
		</HeroStyle>
	);
};

export default Hero;
